import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchLicenseTypes = createAsyncThunk(
  "fetchLicenseTypes",
  async (res) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/license-types?state=${res}`
    );
    return result;
  }
);

export const fetchAddLicenses = createAsyncThunk(
  "fetchAddLicenses",
  async ({ providerId, data }) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/providers/${providerId}/licenses`,
      data
    );
    return result;
  }
);

export const fetchUpdateLicenses = createAsyncThunk(
  "fetchUpdateLicenses",
  async ({ providerId, licenseId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/licenses/${licenseId}?action=update-attributes`,
      data
    );
    return result;
  }
);

export const fetchDeleteLicenses = createAsyncThunk(
  "fetchDeleteLicenses",
  async ({ providerId, licenseId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/licenses/${licenseId}?action=validate-license`,
      data
    );
    return result;
  }
);

export const fetchAddDisciplinaryActions = createAsyncThunk(
  "fetchAddDisciplinaryActions",
  async ({ providerId, data }) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/providers/${providerId}/disciplinary`,
      data
    );
    return result;
  }
);

export const fetchUpdateDisciplinaryActions = createAsyncThunk(
  "fetchUpdateDisciplinaryActions",
  async ({ providerId, licenseId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/disciplinary/${licenseId}?action=update-action`,
      data
    );
    return result;
  }
);

export const fetchVerifyDisciplinaryAction = createAsyncThunk(
  "fetchVerifyDisciplinaryAction",
  async ({ providerId, licenseId, disciplinaryId }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/disciplinary/${licenseId}?action=verify-action`,
      {
        displayId: disciplinaryId,
      }
    );
    return result;
  }
);

export const fetchLicenseInformation = createAsyncThunk(
  "fetchLicenseInformation",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/licenses`
    );
    return result;
  }
);

export const fetchLicenseMoreDetails = createAsyncThunk(
  "fetchLicenseMoreDetails",
  async ({ providerId, licenseId }) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/licenses/${licenseId}?view=extended`
    );

    return result;
  }
);

export const fetchDisciplinaryMoreDetails = createAsyncThunk(
  "fetchDisciplinaryMoreDetails",

  async ({ providerId, licenseId }) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/disciplinary/${licenseId}`
    );

    const updatedResult =
      result.data?.data?.DisciplinaryActionResponseDTO?.disciplinaryActions?.map(
        (item) => ({
          ...item,
          licenseId: licenseId,
        })
      );

    return updatedResult;
  }
);
